import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import L from '../common/localized';

const SubscribeSuccessBox = ({ invertedColors, newDesign }) => (
  <SubscribeSuccessBoxContainer>
    <SubscribeSuccessTitle invertedColors={invertedColors} newDesign={newDesign}>
      <L text='web.subscribe_success_box.subscribe_success_title' isToken />
    </SubscribeSuccessTitle>
    <SubscribeSuccessText invertedColors={invertedColors} newDesign={newDesign}>
      <L text='web.subscribe_success_box.subscribe_success_text' isToken />
    </SubscribeSuccessText>
  </SubscribeSuccessBoxContainer>);

const SubscribeSuccessBoxContainer = styled.div`
  max-width: 480px;
  width: 100%;
  text-align: center;
  margin-bottom: 16px;
`;

const SubscribeSuccessTitle = styled.p`
  font-size: 1.2em;
  font-weight: 700;
  color: ${props => props.newDesign ? '#eee' : (props.invertedColors ? '#f2f2f2' : '#131313')};
  line-height: 1;
  margin-bottom: 8px;

  @media screen and (max-width: 768px) {
    font-size: 0.8em;
  }
`;

const SubscribeSuccessText = styled.p`
color: ${props => props.newDesign ? '#eee' : (props.invertedColors ? '#f2f2f2' : '#131313')};
  line-height: 1;

  @media screen and (max-width: 768px) {
    font-size: 0.8em;
    margin: 0 4px 0 4px;
  }
`;

if (process.env.NODE_ENV !== 'production') {
  SubscribeSuccessBox.propTypes = {
    invertedColors: PropTypes.bool
  };
}

export default SubscribeSuccessBox;
